import React from 'react';
import Footer from '../components/Footer';
import Nav from '../components/Nav';
import bgImg from '../assets/images/hero-bg.jpg';
import BottomNav from '../components/BottomNav';

function Home() {
	return (
		<div className='flex flex-col'>
			<Nav />
			<div
				className='md:landing-photo hero h-56 grayscale'
				style={{ backgroundImage: `url(${bgImg})` }}
			>
				<div className='hero-overlay bg-opacity-30'></div>

				<h1 className='text-center font-heading text-2xl text-base-100 md:mt-20 md:self-start md:text-7xl'>
					Marshall <br></br> Academy of the Arts <br></br> Vocal Music
				</h1>
			</div>
			<div className='bg-secondary p-10 text-center'>
				<p>
					We represent the middle school vocal program of Marshall Academy of
					the Arts in Long Beach, California. Our goal is to create and perform
					music to enrich the lives of the students and the community of Long
					Beach.
				</p>
			</div>
			<BottomNav />
			<Footer />
		</div>
	);
}

export default Home;
